import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { X } from 'lucide-react';
import '../styles/FloatingWhatsAppButton.css';

const FloatingWhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(false);
  };

  const handleWhatsAppClick = () => {
    // Open WhatsApp with pre-filled message
    const phoneNumber = '593999527013';
    const message = 'Hola, quisiera consultar sobre herramientas AECBlock';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  if (!isVisible) {
    return null;
  }

  // Render directly without Portal to avoid creating extra DOM space
  return (
    <div className="floating-whatsapp-button-container">
      <button
        className="floating-whatsapp-button"
        onClick={handleWhatsAppClick}
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        <FaWhatsapp size={28} />
      </button>
      
      <button
        className="whatsapp-close-button"
        onClick={handleClose}
        aria-label="Close WhatsApp button"
        title="Close"
      >
        <X size={12} strokeWidth={3} />
      </button>
    </div>
  );
};

export default FloatingWhatsAppButton;
